'use client'

import React, { FC, memo, useState } from 'react'

import Link from 'next/link'

import { Txt } from 'src/components/atoms'
import { LinkTxt } from 'src/components/molecules'
import { FooterListItem } from 'src/components/molecules/footers/FooterListItem'
import { UsageEnvironmentModal } from 'src/components/organisms'

import { Routes } from 'src/routes'

type Props = {
  isLoggedIn?: boolean
  className?: string
}

export const Footer: FC<Props> = memo(({ isLoggedIn = false, className }) => {
  const [displayUsageEnvironmentModal, setDisplayUsageEnvironmentModal] = useState(false)

  return (
    <footer className={className}>
      <div className="tw-bg-background-secondary tw-px-s4 tw-py-s0 tw-relative">
        <div className="tw-flex tw-justify-between tw-items-center tw-flex-col tablet:tw-flex-row tw-gap-s-2">
          <ul className="tw-text-standardText-secondary tw-flex tw-items-center tw-gap-s0">
            <FooterListItem>
              <Txt className="tw-font-bold" sizeType="s">
                ROOV
              </Txt>
            </FooterListItem>
            {isLoggedIn && (
              <FooterListItem>
                <Link href={Routes.HelpTop.path} target="_blank">
                  <LinkTxt sizeType="s">ヘルプ</LinkTxt>
                </Link>
              </FooterListItem>
            )}
            <FooterListItem>
              <LinkTxt sizeType="s" onClick={() => setDisplayUsageEnvironmentModal(true)}>
                利用環境
              </LinkTxt>
            </FooterListItem>
          </ul>
          <Txt className="tw-text-standardText-secondary" sizeType="s">
            COPYRIGHT ©{' '}
            <a
              href="https://styleport.co.jp/"
              target="_blank"
              rel="noreferrer"
              className="tw-text-standardText-secondary tw-no-underline hover:tw-underline"
            >
              STYLE PORT
            </a>{' '}
            ALL RIGHTS RESERVED
          </Txt>
        </div>
      </div>

      <UsageEnvironmentModal
        isOpen={displayUsageEnvironmentModal}
        onClose={() => setDisplayUsageEnvironmentModal(false)}
      />
    </footer>
  )
})
